import { Banner, Button, CustomLink } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import { BygrProject, BygrProjectDetails } from 'types';
import LinkProjectModal from './LinkProjectModal/LinkProjectModal';
import { createDataTable } from '@ygtechnologies/bygr-frontend-component-library';

interface ProjectLinkedProjectProps {
    project: BygrProjectDetails;
    reloadProject(): void;
}

const ProjectLinkedProject: React.FC<ProjectLinkedProjectProps> = ({ project, reloadProject }) => {
    const [linkProjectModalIsOpen, setLinkProjectModalIsOpen] = useState(false);

    const handleCreateSubProject = () => {
        setLinkProjectModalIsOpen(true);
    };

    const handleSave = () => {
        setLinkProjectModalIsOpen(false);
        reloadProject();
    };

    if (project.isParentProject && project.subProject) {
        const DataTable = createDataTable<BygrProject>();

        return (
            <DataTable data={[project.subProject]} hasPagination={false} className="table style-3">
                <DataTable.Column header="Project Id" field="id" />
                <DataTable.Column
                    header="Name"
                    field="name"
                    renderer={({ row, value }) => <CustomLink to={`/projects/${row.id}`}>{value}</CustomLink>}
                />
            </DataTable>
        );
    } else if (project.parentProjectId !== null) {
        return (
            <>
                <Banner type="danger">You cannot create a sub-project on this project.</Banner>
                <CustomLink to={`/projects/${project.parentProjectId}`}>View parent project</CustomLink>
            </>
        );
    } else {
        return (
            <>
                <Button onClick={handleCreateSubProject} color="tertiary">
                    Create sub-project
                </Button>

                <LinkProjectModal
                    isOpen={linkProjectModalIsOpen}
                    toggle={() => setLinkProjectModalIsOpen(!linkProjectModalIsOpen)}
                    currentProjectId={project.id}
                    onSave={handleSave}
                />
            </>
        );
    }
};

export default ProjectLinkedProject;
